import _ from 'lodash'
import axios from 'axios'
import { getPreviewApiRequest } from './preview'
import { addQueryString } from '@com/utils/url'
import { mindworksInteractiveAdsUrl } from '@pt/config/host'

let source = null
const CancelToken = axios.CancelToken

export default async function getQrcodePreviewUrl({
  state,
  commit,
  rootState,
}) {
  // 预览页面的只读模式使用基础包信息接口中的链接
  if (state.isReadonly) {
    commit('updatePreviewUrl', state.templateConfig.preview_url)
    return
  }

  if (source) {
    console.log('取消上一次预览接口请求')
    source.cancel('cancel request')
  }

  source = CancelToken.source()
  const previewLanguage = state.previewLanguage
  const apiParams = getPreviewApiRequest({
    page: state.page,
    id: state.id,
    templateType: state.templateType,
    skinId: state.skinId, // 只有仓库内部才有 skinId
  })

  const params = { ...apiParams.params, lang: previewLanguage }

  const res = await apiParams.request(params, {
    cancelToken: source.token,
  })
  // 开发环境与测试环境给的 URL 应该是 http 的
  let previewUrl = _.get(res, 'data.data.preview_url')

  // 如果请求时带了语言，那么也需要补上语言（用于代码字预览，代码字读取脚本会先去查看 URL 上是否有 lang 字段，如果有则使用该语言预览）
  // 支持实时预览的包 URL 不能带 lang 查询参数，因为如果 lang 有值，postMessage 过去的语言优先级没有 URL 上的 lang 字段高
  if (previewLanguage && !state.canLivePreview) {
    previewUrl = addQueryString(previewUrl, { lang: previewLanguage })
  }
  // 加随机参数是为了处理缓存问题
  previewUrl = addQueryString(previewUrl, {
    preview: true,
    mw_test: 0,
    loading: 1,
    random: new Date().getTime() * Math.random(),
  })
  const queryData = {
    url: previewUrl,
    is_browser_tips: 1,
    mw_test: process.env.NODE_ENV === 'production' ? 0 : 1,
  }
  // 只有在 PT 上面才会有埋点上报，包含定制、通用制作和多组合制作
  if (state.isCommonTemplateCustom || state.isCreativeTemplateCustom) {
    const getSct = () => {
      if (state.isCommonTemplateCustom) {
        return 'pt_project_normal'
      }
      return 'pt_project_custom_normal'
    }
    queryData.track_data = JSON.stringify({
      pid: state.id,
      skin_id: state.skinId,
      uid: rootState.user.info.id,
      ptloading: 1, // 是否使用pt loading
      env: process.env.NODE_ENV === 'production' ? 'p' : 't',
      sct: getSct(),
      cc: rootState.user.info.cc || -1,
    })
  }
  state.qrcodeUrl = addQueryString(mindworksInteractiveAdsUrl, queryData)
  return state.qrcodeUrl
}
